import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './carousel.module.scss';
// import EducationBackground from 'assets/images/backgrounds/education.jpeg';
import EducationBackground2 from 'assets/images/backgrounds/education2.jpeg';
// import WorkBackground from 'assets/images/backgrounds/work.jpeg';
import Work2Background from 'assets/images/backgrounds/work2.png';
// import CoupleBackground from 'assets/images/backgrounds/couple.jpeg';
import Couple2Background from 'assets/images/backgrounds/couple2.png';
import FriendsBackground from 'assets/images/backgrounds/friends.jpeg';
// import Quote from './quote.svg';

const Carousel: React.FC = () => {
    const slides = [
        {
            image: Couple2Background,
            quote: 'FuelBox sparked conversations we never knew we needed—our relationship has never been stronger!',
            author: '- Anna & Thomas',
        },
        {
            image: Work2Background,
            quote: 'FuelBox brought our team closer, transforming meetings into engaging, meaningful conversations.',
            author: '- Julia, Team leader',
        },
        {
            image: EducationBackground2,
            quote: 'FuelBox helps my students share their thoughts and feelings openly, making our classroom warmer and friendlier.',
            author: 'Martin, 4th grade teacher',
        },
        {
            image: FriendsBackground,
            quote: 'FuelBox has become our go-to for gatherings—deep chats, endless laughs, and unforgettable moments!',
            author: '- Sophie ',
        },
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        // dotsClass: 'dots',
    };

    return (
        <div className={styles.carouselContainer}>
            <Slider {...settings} className='slider'>
                {slides.map((slide, index) => (
                    <div key={index} className={styles.slide}>
                        <img src={slide.image} alt='FuelBox' />
                        <div className={styles.textOverlay}>
                            {/* <img
                                className={styles.quoteIcon}
                                src={Quote}
                                alt=''
                            /> */}
                            {/* <p className={styles.quote}>{slide.quote}</p>
                            <p className={styles.author}>{slide.author}</p> */}
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default Carousel;
